import { wafFetch } from "./awsWafIntegration";
import { PublicProviderProfile } from "../types/providerProfile";

export class ProviderProfileNotFoundError extends Error {}

export async function fetchProviderProfile(uuid: string): Promise<PublicProviderProfile> {
  const url = `${import.meta.env.VITE_UNYTE_WEBHOOKS_URL}/provider-profile?uuid=${encodeURIComponent(uuid)}`;
  const response = await wafFetch(url, { method: "GET" });

  if (response.status === 404) {
    throw new ProviderProfileNotFoundError("Provider not found");
  }

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.error || `Failed to fetch provider profile (${response.status})`);
  }

  const { provider } = await response.json();
  return provider;
}
